import React, { Component, Fragment } from 'react'
import { MDXProvider } from '@mdx-js/tag'
import { StaticQuery, graphql, Link } from 'gatsby'
import styled from 'styled-components'
import { Flex, Box } from 'grid-styled'
import { Helmet } from 'react-helmet'

import Container from '../components/Container'
import Footer from '../components/Footer'
import H1 from '../components/H1'
import P from '../components/P'
import Strong from '../components/Strong'
import Image from '../components/Image'

const Row = props => <Flex {...props} mx={'-2vw'} />
const Column = props => <Box {...props} px={'2vw'} flex='1 1 auto' />

const FixedBox = styled(Box)`
  position: fixed;
  z-index: 999;
  @media (max-width: 40em) {
    position: relative;
  }
`

const StyledLink = styled(Link)`
  text-decoration: none;
  /* border-bottom: 3px solid #2121214a; */
  color: #${props => (props.color ? props.color : 'inherit')};
`

const TextColor = styled.div`
  color: #${props => props.color};
  p {
    color: #${props => props.color};
  }
`
TextColor.defaultProps = {
  color: '#000'
}

class WorkPageLayout extends Component {
  render () {
    const { pathname } = this.props.location

    return (
      <MDXProvider
        components={{
          h1: H1,
          p: P,
          strong: Strong,
          img: Image
        }}
      >
        <Fragment>
          <StaticQuery
            query={graphql`
              {
                allMdx {
                  edges {
                    node {
                      id
                      frontmatter {
                        title
                        description
                        path
                        background
                        color
                      }
                    }
                  }
                }
              }
            `}
            render={({ allMdx }) => {
              const { node } =
                allMdx.edges.find(edge => edge.node.frontmatter.path === pathname) || ''
              return (
                <Fragment>
                  <Helmet>
                    <title>{`Feed - ${node && node.frontmatter.title}`}</title>
                    <meta name='description' content={node && node.frontmatter.description} />
                  </Helmet>
                  <Container bg={node && node.frontmatter.background}>
                    <FixedBox>
                      <H1 color={node && node.frontmatter.color}>
                        <StyledLink to='/' color={node && node.frontmatter.color}>
                          Feed
                        </StyledLink>{' '}
                        / {node && node.frontmatter.title}
                      </H1>
                    </FixedBox>
                    <Row mt={[0, '6vw']}>
                      <Column
                        width={5 / 12}
                        ml={[0, 'calc(100% / 12)']}
                        mr={[0, 'calc(100% / 12)']}
                      >
                        <TextColor color={node && node.frontmatter.color}>
                          {this.props.children}
                        </TextColor>
                      </Column>
                    </Row>
                  </Container>
                  <Footer
                    color={node && node.frontmatter.color}
                    bg={node && node.frontmatter.background}
                  />
                </Fragment>
              )
            }}
          />
        </Fragment>
      </MDXProvider>
    )
  }
}

export default WorkPageLayout
